export const tr = {
    horizontal: 'Yatay',
    square: 'Kare',
    vertical: 'Dikey'
};
